module.exports = __webpack_public_path__ + "static/media/icon-piece6-2.8292ecbe.png";